module.exports = __webpack_public_path__ + "img/SketchPnge009313d88a39ac5db573737286e2de04ac7f6e7d1d48b2a14ce8d64bec3ad07.fd4913ee.png";